import { render } from "./ProjectsSidebar.vue?vue&type=template&id=1c79dfce&scoped=true"
import script from "./ProjectsSidebar.vue?vue&type=script&lang=js"
export * from "./ProjectsSidebar.vue?vue&type=script&lang=js"

import "./ProjectsSidebar.vue?vue&type=style&index=0&id=1c79dfce&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c79dfce"]])

export default __exports__